(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-enquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pick(value) {
    var sel = document.querySelector('[data-le-inquiry-select]');
    if (!sel || !value) return;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value.toLowerCase() === value.toLowerCase()) { sel.selectedIndex = i; break; }
    }
  }
  try {
    var q = new URLSearchParams(window.location.search);
    if (q.get('inquiry')) pick(q.get('inquiry'));
    var home = q.get('home');
    var f = document.querySelector('[data-le-home-field]');
    if (home && f) f.value = home;
  } catch (e) {}
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-le-enquiry]');
    if (a) pick(a.getAttribute('data-le-enquiry'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["le-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function play(v) { var card = v.closest('.le-reel'); var p = v.play(); if (p && p.then) { p.then(function () { card.classList.add('is-playing'); }).catch(function () {}); } else { card.classList.add('is-playing'); } }
  function stop(v) { v.pause(); var card = v.closest('.le-reel'); card.classList.remove('is-playing'); }
  function initVideos(root) {
    if (reduce) return;
    var vids = root.querySelectorAll('.le-reel__video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.removeAttribute('controls'); v.setAttribute('preload', 'metadata'); });
    if (canHover) {
      vids.forEach(function (v) {
        var card = v.closest('.le-reel');
        card.addEventListener('mouseenter', function () { play(v); });
        card.addEventListener('mouseleave', function () { stop(v); });
      });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) play(e.target); else stop(e.target); });
      }, { threshold: 0.75 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }

  var dlg, frame, igLink, titleEl, subEl, descEl, showLink;
  function buildLightbox() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'le-lb';
    dlg.setAttribute('aria-label', 'Film');
    dlg.innerHTML = "<button type='button' class='le-lb__close' aria-label='Close'>&times;</button>" +
      "<div class='le-lb__inner'>" +
        "<div class='le-lb__frame'><iframe title='Loren Estates film' allow='autoplay; encrypted-media; picture-in-picture; clipboard-write' allowfullscreen></iframe></div>" +
        "<aside class='le-lb__panel'>" +
          "<p class='le-lb__eyebrow'></p>" +
          "<h2 class='le-lb__title'></h2>" +
          "<p class='le-lb__desc'></p>" +
          "<div class='le-lb__links'><a class='le-lb__show'>Arrange a private showing</a><a class='le-lb__ig' target='_blank' rel='noopener'>View on Instagram</a></div>" +
          "<p class='le-lb__note'>Featured for editorial purposes. Homes may be represented by other brokerages, and details are subject to change.</p>" +
        "</aside>" +
      "</div>";
    document.body.appendChild(dlg);
    frame = dlg.querySelector('iframe');
    igLink = dlg.querySelector('.le-lb__ig');
    showLink = dlg.querySelector('.le-lb__show');
    titleEl = dlg.querySelector('.le-lb__title');
    subEl = dlg.querySelector('.le-lb__eyebrow');
    descEl = dlg.querySelector('.le-lb__desc');
    dlg.querySelector('.le-lb__close').addEventListener('click', closeLightbox);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeLightbox(); });
    dlg.addEventListener('close', function () { frame.src = 'about:blank'; document.documentElement.style.overflow = ''; });
  }
  function closeLightbox() { if (dlg && dlg.open) dlg.close(); }
  function openLightbox(a) {
    var url = a.getAttribute('data-le-ig');
    var title = a.getAttribute('data-le-title') || '';
    var sub = a.getAttribute('data-le-sub') || '';
    var desc = a.getAttribute('data-le-desc') || '';
    var m = url.match(/instagram\.com\/(?:[^\/?#]+\/)?(reel|reels|p|tv)\/([A-Za-z0-9_-]+)/);
    if (!m) return false;
    buildLightbox();
    if (typeof dlg.showModal !== 'function') return false;
    var kind = m[1] === 'reels' ? 'reel' : m[1];
    frame.src = 'https://www.instagram.com/' + kind + '/' + m[2] + '/embed/';
    igLink.href = url;
    showLink.href = '/pages/contact?inquiry=' + encodeURIComponent('Private showing') + '&home=' + encodeURIComponent(title) + '#inquire';
    titleEl.textContent = title;
    subEl.textContent = sub;
    subEl.hidden = !sub;
    descEl.textContent = desc;
    descEl.hidden = !desc;
    dlg.showModal();
    dlg.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden';
    return true;
  }
  if (!window.__leReelsBound) {
    window.__leReelsBound = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-le-ig]');
      if (!a) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (openLightbox(a)) e.preventDefault();
    });
  }
  initVideos(document);
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
